"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _shoudSkipPdpLinkQuery = require("./shoudSkipPdpLinkQuery");
Object.keys(_shoudSkipPdpLinkQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shoudSkipPdpLinkQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shoudSkipPdpLinkQuery[key];
    }
  });
});
var _shouldSkipCatalogueLinkQuery = require("./shouldSkipCatalogueLinkQuery");
Object.keys(_shouldSkipCatalogueLinkQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shouldSkipCatalogueLinkQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldSkipCatalogueLinkQuery[key];
    }
  });
});
